define('NSeComm.CartToQuote.Shopping', [
    'CartToQuote.Button.PDP.View',
    'CartToQuote.Button.View',
    'CartToQuote.Helper',
    'CartToQuote.DynamicCSS',
    'jQuery',
    'underscore'
], function CartToQuoteShopping(
    CartToQuoteButtonPDPView,
    CartToQuoteButtonView,
    CartToQuoteHelper,
    DynamicCSS,
    jQuery,
    _
) {
    'use strict';

    var ADD_TO_QUOTE_TITLE = CartToQuoteHelper.getConst('itemToQuoteTitle');
    var CART_TO_QUOTE_TITLE = CartToQuoteHelper.getConst('cartToQuoteTitle');
    var CART_TO_QUOTE_URL_FRAGMENT = CartToQuoteHelper.getConst('cartToQuoteFragment');

    return {
        mountToApp: function mountToApp(container) {
            var layout = container.getComponent('Layout');
            var config = container.getComponent('Environment').getConfig('cartToQuote');

            var cart = container.getComponent('Cart');
            var cartToQuoteViewFn = function cartToQuoteView() {
                return new CartToQuoteButtonView({
                    container: container,
                    configuration: config,
                    pageInfo: {
                        fragment: CART_TO_QUOTE_URL_FRAGMENT,
                        title: CART_TO_QUOTE_TITLE
                    }
                });
            };

            var pdp = container.getComponent('PDP');
            var pdpAddToQuotePlaceholder = 'ProductDetails.AddToQuote';

            if (layout) {
                if (config.showInMiniCart) {
                    layout.addChildView('MiniCart.Actions', cartToQuoteViewFn);
                }

                if (config.showInSummary) {
                    layout.addChildView('cms:cart_summary_cms_area_3', cartToQuoteViewFn);
                }

                layout.addToViewContextDefinition('Cart.Detailed.View', 'afterRender', 'object', function afterCartDetailedRender() {
                    var deferred = jQuery.Deferred();

                    deferred.then(function afterRender() {
                        layout.cancelableTrigger('afterCartDetailedShow');
                    });
                    return deferred.resolve();
                });

                layout.on('afterCartDetailedShow', function afterCartDetailedShow() {
                    cart.getLines().then(function afterGetLines(lines) {
                        var cpqGroups = {};
                        var lineIds = CartToQuoteHelper.cartLinesToCpq(lines).map(function eachLine(ln) {
                            cpqGroups[ln.internalid] = ln.cpqGroup;
                            return ln.cpqStatus && ln.cpqLevel === 'subitem' ? '#' + ln.internalid : '';
                        }).filter(function eachLine(ln) { return Boolean(ln); });

                        // Sublines
                        jQuery(lineIds.join(',')).each(function eachLine() {
                            var $row = jQuery(this).attr('data-cpq-type', 'subitem').attr('data-cpq-item', cpqGroups[this.id]);
                            var $qty = $row.find('[data-action="update-quantity"] [name="quantity"]');

                            $qty.parent().html('<span>' + $qty.val() + '</span>');
                        });

                        lineIds = _(
                            _(cpqGroups).values()
                        ).uniq().map(function eachValue(value) { return '#' + value; });

                        // Main lines
                        jQuery(lineIds.join(',')).each(function eachLine() {
                            jQuery(this).after(
                                jQuery('[data-cpq-item="' + this.id + '"]')
                            );
                        });
                    });
                });

                layout.on('beforeShowContent', function beforeShowContent() {
                    if (config.noReorder) {
                        DynamicCSS.hideReorders();
                    }
                    if (config.noReturns) {
                        DynamicCSS.hideReturns();
                    }
                    if (config.noWishlist) {
                        DynamicCSS.hideProductLists();
                    }
                });

                layout.on('afterShowContent', function afterShowContent() {
                    if (config.noWishlist) {
                        jQuery('[data-view="Header.Menu.MyAccount"] [name="Wishlist"]').closest('.header-menu-myaccount-item-level2').remove();
                    }
                });
            }

            if (pdp) {
                pdp.addChildView(pdpAddToQuotePlaceholder, function cartToQuoteView() {
                    return new CartToQuoteButtonPDPView({
                        container: container,
                        configuration: config,
                        pageInfo: {
                            placeholder: pdpAddToQuotePlaceholder,
                            title: ADD_TO_QUOTE_TITLE
                        }
                    });
                });

                pdp.addToViewContextDefinition('ProductDetailToQuote.View', 'afterRender', 'object', function afterAddToQuoteRender(context) {
                    var deferred = jQuery.Deferred();

                    deferred.then(function afterRender() {
                        pdp.cancelableTrigger('afterAddToQuoteShow', context);
                    });
                    return deferred.resolve();
                });

                pdp.on('afterAddToQuoteShow', function afterAddToQuoteShow(addToQuoteContext) {
                    var $addToQuoteButton = jQuery('[data-type="add-to-quote"]');

                    if ($addToQuoteButton.length && config.override) {
                        $addToQuoteButton.remove();
                        pdp.cancelableTrigger('addToQuoteOverride', addToQuoteContext);
                    }
                });
            }
        }
    };
});
